/*
 * Created on 02.04.2016
 *
 * Copyright(c) 1995 - 2016 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

/**
 * Model für die sort und page.
 *
 * @author imam
 */
export class Sort {

    direction: string;
    property: string;
    ignoreCase: boolean;
    nullHandling: string;
    ascending: boolean;
}

export class Page {
    content: Array<any>;
    totalPages: number;
    totalElements: number;
    last: boolean;
    size: number;
    number: number;
    selectedPage: number;
    sort: Sort[];
    first: boolean;
    numberOfElements: number;
}
